import { render, staticRenderFns } from "./AnxContainer.vue?vue&type=template&id=23cb9858&scoped=true&"
import script from "./AnxContainer.vue?vue&type=script&lang=ts&"
export * from "./AnxContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AnxContainer.vue?vue&type=style&index=0&id=23cb9858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb9858",
  null
  
)

export default component.exports